var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.newNav = function() {
	if ($(".site-header .dropdown-toggle").length) {
		$(".site-header .dropdown-toggle").on("click", function() {
			$("body").addClass("nav-open");
		});
		$("#dropdown-nav").on("hide.bs.dropdown", function() {
			$("body").removeClass("nav-open");
		});
	}
}();